module.exports = __webpack_public_path__ + "static/img/1-2.8c84dd1.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/1-2.png
// module id = OrmJ
// module chunks = 1